import { render, staticRenderFns } from "./CompanyDataForm.vue?vue&type=template&id=3911a3c2&"
import script from "./CompanyDataForm.vue?vue&type=script&lang=js&"
export * from "./CompanyDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports